(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22250,93812],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 51781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_ResultsSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/ResultsSection/utils/useResultsSection.js


var useResultsSection = function(param) {
    var data = param.data, type = param.type;
    var ref, ref1;
    var title = data.title, subtitle = data.subtitle, description = data.description, images = data.images, contentModules = data.contentModules, view = data.view, background = data.background;
    var sectionBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(background), {
        fm: "webp"
    });
    var sectionStyle = sectionBackgroundImage ? {
        backgroundImage: "url(".concat(sectionBackgroundImage, ")")
    } : {};
    var moduleData = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", {}), [
        "images",
        "imagesBundles",
        "contentModules", 
    ]);
    var screenUrl = (0,helper/* getFileUrl */.qm)(moduleData === null || moduleData === void 0 ? void 0 : (ref = moduleData.images) === null || ref === void 0 ? void 0 : ref[0]);
    var imagesBundles = (moduleData === null || moduleData === void 0 ? void 0 : (ref1 = moduleData.imagesBundles) === null || ref1 === void 0 ? void 0 : ref1.map(function(bundle) {
        return (0,helper/* getFileUrl */.qm)(bundle);
    })) || [];
    var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(moduleData.contentModules, "[0]", {}), [
        "url"
    ]), prototypeLink = ref2.url;
    return {
        view: view,
        type: type,
        title: title,
        subtitle: subtitle,
        description: description,
        screenUrl: screenUrl,
        imagesBundles: imagesBundles,
        images: images,
        sectionStyle: sectionStyle,
        prototypeLink: prototypeLink
    };
};

// EXTERNAL MODULE: ./UI/sections/ResultsSection/styles.module.scss
var styles_module = __webpack_require__(91208);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/ResultsSection/index.jsx









var FigmaPrototype = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 32293).then(__webpack_require__.bind(__webpack_require__, 32293));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32293)
            ];
        }
    }
});
var ResultsSection = function(props) {
    var ref = useResultsSection(props), view = ref.view, type = ref.type, title = ref.title, subtitle = ref.subtitle, description = ref.description, screenUrl = ref.screenUrl, imagesBundles = ref.imagesBundles, sectionStyle = ref.sectionStyle, images = ref.images, prototypeLink = ref.prototypeLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).container, (styles_module_default())[type], (styles_module_default())[view]),
        style: sectionStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                className: (styles_module_default()).sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        transparent: true,
                        className: (styles_module_default()).screen,
                        src: screenUrl,
                        alt: screenUrl
                    }),
                    prototypeLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(FigmaPrototype, {
                        src: prototypeLink,
                        className: (styles_module_default()).figmaPrototype
                    }),
                    images === null || images === void 0 ? void 0 : images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                            asset: image,
                            className: classnames_default()((styles_module_default()).media, (styles_module_default())["media-".concat(index + 1)])
                        }, "".concat(index + 1));
                    }),
                    imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(bundleUrl, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                            className: classnames_default()((styles_module_default()).imageBundle, (styles_module_default())["imageBundle-".concat(index + 1)]),
                            src: bundleUrl,
                            alt: type
                        }, "result-images-bundles/".concat(bundleUrl));
                    })
                ]
            })
        ]
    });
};
ResultsSection.prototype = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_ResultsSection = (ResultsSection);


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 91208:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AUStL","sectionTitle":"styles_sectionTitle__hJVnQ","contentWrapper":"styles_contentWrapper__HQUqw","screen":"styles_screen__qpthW","media":"styles_media__Wk_b9","prototype":"styles_prototype__LGC6a","stickerbox":"styles_stickerbox__K5Wfo","fireaway":"styles_fireaway__5VzkL","firstSectionView":"styles_firstSectionView__TGzhh","imageBundle":"styles_imageBundle__4v7Be","imageBundle-1":"styles_imageBundle-1__blZFq","imageBundle-2":"styles_imageBundle-2__RmvIb","secondSectionView":"styles_secondSectionView__X6qqA","thirdSectionView":"styles_thirdSectionView__eQJyu","fairy":"styles_fairy__5Pf8y","hotel-data-cloud":"styles_hotel-data-cloud__uE30v","open-sense":"styles_open-sense__jbZ60","tell":"styles_tell__x_Yzk","ubichat":"styles_ubichat__BfFUY","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__wmnGC","fusion-markets":"styles_fusion-markets__EtTdQ","fourthSectionView":"styles_fourthSectionView__r4I0C","telemojo":"styles_telemojo__64pTO","blackbird":"styles_blackbird__7udm0","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__loc_3","smartcenter":"styles_smartcenter__QHxZ4","dindon":"styles_dindon__1xXiF","humankind":"styles_humankind__BpzEn","cinnabar":"styles_cinnabar__pPEtd","software-for-mri-interpretation":"styles_software-for-mri-interpretation__2GDrm","mobile-budgeting-app":"styles_mobile-budgeting-app__2FZ6Q","forex-trading-platform":"styles_forex-trading-platform__hASTo","why-us":"styles_why-us__x5Kce","media-2":"styles_media-2__eJOeP","media-1":"styles_media-1___08j_","cctv-footage-analytics":"styles_cctv-footage-analytics__oiY5D","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__zDX3W","web-p2p-lending-platform":"styles_web-p2p-lending-platform__xj_dh","mobile-music-app":"styles_mobile-music-app__20LpI","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__GlI3S","crowdfunding-platform":"styles_crowdfunding-platform__HMyqb","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__SucJG","custom-payment-gateway":"styles_custom-payment-gateway__pcR3R","ai-documentation-processing":"styles_ai-documentation-processing__pJTL4","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__kWIL8","ai-based-travel-planner":"styles_ai-based-travel-planner__66cch","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__TI2YR","blinking":"styles_blinking__aROLC","swing":"styles_swing__HP5Hk","animateborder":"styles_animateborder__ApCXN","animateborder-overlay":"styles_animateborder-overlay__WQ3RY","animatecircle":"styles_animatecircle__t4hP_","animatedot":"styles_animatedot__jltmt","animStar":"styles_animStar___ZAt9","hideText":"styles_hideText__MZDCe","spin":"styles_spin__b2GDX","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__Z8vHd","outOfTransparencyMobile":"styles_outOfTransparencyMobile__aWSIQ","appearance":"styles_appearance__J_nyc","appearanceFromBelow":"styles_appearanceFromBelow__ixFaM","flicker":"styles_flicker__cU_VL","vibrate1":"styles_vibrate1__Ld3za","rocket":"styles_rocket__gaqqZ","burgerItem1":"styles_burgerItem1__oXwVi","burgerItem2":"styles_burgerItem2__01AGq","burgerItem3":"styles_burgerItem3__0aA0K","burgerItem1Reverse":"styles_burgerItem1Reverse__RXjud","burgerItem2Reverse":"styles_burgerItem2Reverse__030S2","burgerItem3Reverse":"styles_burgerItem3Reverse___YRqL","arrow-down":"styles_arrow-down__5zbBs","image-scroll":"styles_image-scroll__q5CeJ","image-scroll-reverse":"styles_image-scroll-reverse__9KdwO","stickerbox-pointer-move":"styles_stickerbox-pointer-move__tUoja","hide-image":"styles_hide-image__uO9xh","stickerbox-pointer-second":"styles_stickerbox-pointer-second__QPO6I","stickerbox-pointer-third":"styles_stickerbox-pointer-third__Bz__P","cedar-bounce":"styles_cedar-bounce__tTNdU"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);